<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-flex align-items-center justify-content-between flex-wrap pb-0"
      >
        <div class="d-flex flex-column mb-2">
          <h3 class="mb-0 font-size-24 text-primary">{{ $t(title) }}</h3>
          <h5 class="mb-0 mt-3 fw-normal font-size-15" v-if="subtitle.length">
            {{ $t(subtitle) }}
          </h5>
        </div>

        <div class="page-title-right">
          <slot />
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
